exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".cart-subscribe-and-save[data-v-1f37ecb0] {\n  display: flex;\n  flex-direction: row;\n}\n", ""]);

// exports
